import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.network.widget.graph');
import { OnInit, Input, ViewChild, AfterViewInit, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';
import { DataSet } from 'vis-data';
import { Network } from 'vis-network';

@Component({
    selector: 'wiz-portal-network-widget-graph',
template: templateSource || '',
    styles: [``],
})
export class PortalNetworkWidgetGraphComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;
    @ViewChild('network', { static: true }) networkContainer!: ElementRef;


    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    //data
    public researcher: any;
    public products: any;
    public mapping: any;
    public periodStart = 0;
    public periodEnd = 0;

    //graph
    public network!: Network;
    private nodesDS!: DataSet<any>;
    private edgesDS!: DataSet<any>;

    private originalNodeStyle = new Map<string, any>();
    private originalEdgeStyle = new Map<string, any>();

    public rendering = true;
    public loadingChar = Array.from('그래프 생성중입니다...');

    private selected: { type: 'node' | 'edge'; id: string } | null = null;

    private deepClone<T>(v: T): T {
        return v == null ? v : JSON.parse(JSON.stringify(v));
    }


    public async ngOnInit() {
        this.researcher = this.data.researcher;
        this.service.render();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            this.periodEnd = this.period.end;
            this.periodStart = this.period.start;
            this.load();
        }
        this.service.render();
    }

    public async load() {
        this.rendering = true;
        this.products = (this.data.products ?? []).filter(p => {
            const year = Number(p.pub_year);
            return year && year >= this.periodStart && year <= this.periodEnd;
        });
        const data = await wiz.call("mapping", { products: JSON.stringify(this.products) });
        this.mapping = data.data;
        await this.service.render();
        await this.buildNetwork();
        await this.service.render();
    }

    private async buildNetwork() {
        if (this.network) {
            this.network.destroy();
            this.selected = null;
        }

        // 1) 중간 계산용 구조
        const edgeWeights = new Map<string, number>();
        const edgeYears = new Map<string, Set<number>>();

        const allAuthors = new Set<string>();
        const centerId = this.researcher.auth_id;

        // 2) products 기반으로 edge 가중치/연도 계산
        this.products.forEach((p) => {
            const authors = (p.auth_list || "")
                .split(";")
                .map(a => a.trim())
                .filter(Boolean);

            authors.forEach(a => allAuthors.add(a));

            for (let i = 0; i < authors.length; i++) {
                for (let j = i + 1; j < authors.length; j++) {
                    const a1 = authors[i];
                    const a2 = authors[j];
                    if (a1 === a2) continue;

                    // 순서 고정 (a|b)
                    const a = a1 < a2 ? a1 : a2;
                    const b = a1 < a2 ? a2 : a1;
                    const key = `${a}|${b}`;

                    // 가중치 +1
                    edgeWeights.set(key, (edgeWeights.get(key) || 0) + 1);

                    // 연도 기록
                    if (!edgeYears.has(key)) {
                        edgeYears.set(key, new Set<number>());
                    }
                    if (p.pub_year) {
                        edgeYears.get(key)!.add(Number(p.pub_year));
                    }
                }
            }
        });

        // 3) 노드의 수를 먼저 계산
        const authorCount = allAuthors.size;
        let EDGE_THRESHOLD = 1;
        if (authorCount >= 200) {
            EDGE_THRESHOLD = 10;
        } else if (authorCount >= 50) {
            EDGE_THRESHOLD = 5;
        }

        const nodeItems: any[] = [];
        const edgeItems: any[] = [];

        const usedNodeIds = new Set<string>();

        // 4) 엣지 생성 + 사용된 노드 기록
        for (const [key, w] of edgeWeights.entries()) {
            if (w < EDGE_THRESHOLD) {
                continue;
            }

            const [from, to] = key.split("|");
            const yearsSet = edgeYears.get(key);
            const years = yearsSet ? Array.from(yearsSet).sort() : [];

            const fromName = this.mapping?.[from] ?? from;
            const toName = this.mapping?.[to] ?? to;

            // title 생성: 공동연구 수 중심
            let title = `${fromName} - ${toName}\n공동 연구 수: ${w}건`;

            // 연도가 하나라도 있을 때만 붙이기
            if (years.length) {
                title += `\n공동연도: ${years.join(", ")}`;
            }

            edgeItems.push({
                id: key,
                from,
                to,
                value: w,
                width: 1,
                color: { color: '#94a3b8' },
                font: { align: 'middle', size: 10 }
            });

            usedNodeIds.add(from);
            usedNodeIds.add(to);
        }

        usedNodeIds.add(centerId);

        // 3) 노드별 "전체 연구 개수" 계산 (products 기준)
        const nodeResearchCount = new Map<string, number>();

        this.products.forEach((p) => {
            const authors = (p.auth_list || "")
                .split(";")
                .map(a => a.trim())
                .filter(Boolean);

            authors.forEach((authorId) => {
                nodeResearchCount.set(
                    authorId,
                    (nodeResearchCount.get(authorId) || 0) + 1
                );
            });
        });

        const maxCount = Math.max(...Array.from(nodeResearchCount.values()), 1);
        const minCount = 1;

        // const auth_list = Array.from(usedNodeIds);
        // const result = await wiz.call("search", { 'auth_list': JSON.stringify(auth_list) });
        const counts = Array.from(nodeResearchCount.values());
        const sorted = counts.slice().sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        const median =
            sorted.length % 2 !== 0
                ? sorted[mid]
                : Math.round((sorted[mid - 1] + sorted[mid]) / 2);


        // 노드 생성    
        usedNodeIds.forEach((id) => {
            const isCenter = id === centerId;
            const researchCount = nodeResearchCount.get(id) || 0;
            const value = isCenter ? Math.max(1, median) : Math.max(1, researchCount);
            const labelName = isCenter
                ? this.researcher.kr_name
                : (this.mapping?.[id] ?? id);

            const color = isCenter
                ? '#F97116'
                : this.getGradientBlue(value, minCount, maxCount);

            const node: any = {
                id,
                label: labelName,
                title: isCenter
                    ? `연구자 : ${labelName}`
                    : `연구자 : ${labelName}\n 전체 공동 연구 수 : ${researchCount}건`,
                color: {
                    background: color,
                    border: color
                },
                value: value
            };

            if (isCenter) {
                node.x = 0;
                node.y = 0;
                node.fixed = { x: true, y: true };
                node.physics = false;
            }

            nodeItems.push(node);
        });


        // 6) DataSet 생성
        this.nodesDS = new DataSet<any>(nodeItems);
        this.edgesDS = new DataSet<any>(edgeItems);
        const data = { nodes: this.nodesDS, edges: this.edgesDS };

        this.originalNodeStyle.clear();
        this.originalEdgeStyle.clear();

        this.nodesDS.forEach((n: any) => {
            this.originalNodeStyle.set(n.id, {
                color: this.deepClone(n.color),
                font: this.deepClone(n.font),
                value: n.value,
                borderWidth: n.borderWidth ?? 1
            });
        });

        this.edgesDS.forEach((e: any) => {
            this.originalEdgeStyle.set(e.id, {
                color: this.deepClone(e.color),
                width: e.width ?? 1,
                font: this.deepClone(e.font)
            });
        });

        // 물리 옵션
        // const nodeCount = usedNodeIds.size;
        let iterations = 500;
        // if (nodeCount < 50) iterations = 50;
        // else if (nodeCount < 100) iterations = 300;
        // else iterations = 500;

        const options: any = {
            nodes: {
                shape: 'dot',
                scaling: { min: 15, max: 70 },
                font: {
                    size: 18,
                }

            },
            edges: {
                scaling: { min: 1, max: 8 },
                color: { color: '#94a3b8' },
            },
            layout: {
                improvedLayout: false
            },
            physics: {
                enabled: true,
                stabilization: { iterations },
                solver: 'barnesHut',
                barnesHut: {
                    avoidOverlap: 1,
                    centralGravity: 0.2,
                    springLength: 50,
                    springConstant: 0.02
                },
            },
            interaction: {
                hover: true,
                tooltipDelay: 50,
            },
        };

        this.network = new Network(this.networkContainer.nativeElement, data, options);

        this.network.once("stabilizationIterationsDone", () => {
            this.network.setOptions({ physics: false });
            this.rendering = false;
            this.service.render();

        });

        this.network.on("doubleClick", (params) => {
            if (params.nodes.length > 0) {
                const clickedNodeId = params.nodes[0];
                window.open(`/detail/${clickedNodeId}`, "_blank");
            }
        });

        this.network.on("click", (params) => {
            const nodeId = params.nodes?.length ? String(params.nodes[0]) : null;
            const edgeId = params.edges?.length ? String(params.edges[0]) : null;

            // ✅ 빈 공간 클릭 => 원복
            if (!nodeId && !edgeId) {
                this.selected = null;
                this.restoreStyles();
                return;
            }

            // ✅ edge 클릭이 우선 (겹칠 수 있어서)
            if (edgeId) {
                // 토글: 같은 edge 다시 클릭 => 원복
                if (this.selected?.type === 'edge' && this.selected.id === edgeId) {
                    this.selected = null;
                    this.restoreStyles();
                    return;
                }

                this.selected = { type: 'edge', id: edgeId };
                this.restoreStyles();
                this.highlightByEdge(edgeId);
                return;
            }

            // ✅ node 클릭
            if (nodeId) {
                // 토글: 같은 node 다시 클릭 => 원복
                if (this.selected?.type === 'node' && this.selected.id === nodeId) {
                    this.selected = null;
                    this.restoreStyles();
                    return;
                }

                this.selected = { type: 'node', id: nodeId };
                this.restoreStyles();
                this.highlightByNode(nodeId);
            }
        });

    }

    private highlightByNode(nodeId: string): void {

        if (!this.network || !this.nodesDS || !this.edgesDS) return;
        const connectedEdges = new Set<string>();
        const connectedNodes = new Set<string>([String(nodeId)]);

        this.edgesDS.forEach((e: any) => {
            const from = String(e.from);
            const to = String(e.to);
            if (from === String(nodeId) || to === String(nodeId)) {
                connectedEdges.add(String(e.id));
                connectedNodes.add(from);
                connectedNodes.add(to);
            }
        });

        // nodes: OFF는 흐림
        const nodeUpdates: any[] = [];
        this.nodesDS.forEach((n: any) => {
            const isOn = connectedNodes.has(String(n.id));
            const orig = this.originalNodeStyle.get(n.id);

            if (isOn) {
                // ✅ 연결된 노드도 눈에 띄게 하이라이트
                nodeUpdates.push({
                    id: n.id,
                    color: orig ? this.deepClone(orig.color) : n.color,
                    borderWidth: 3,
                    font: { ...(orig?.font ?? n.font ?? {}), color: '#111827' }
                });
            } else {
                nodeUpdates.push({
                    id: n.id,
                    borderWidth: 1,
                    color: { background: 'rgba(148,163,184,0.20)', border: 'rgba(148,163,184,0.20)' },
                    font: { ...(n.font ?? {}), color: 'rgba(112,121,136,0.35)' }
                });
            }
        });

        // edges: ON만 진하게 / OFF는 흐림
        const edgeUpdates: any[] = [];
        this.edgesDS.forEach((e: any) => {
            const isOn = connectedEdges.has(String(e.id));
            edgeUpdates.push({
                id: e.id,
                width: isOn ? 2 : 1,
                color: isOn ? { color: '#64748B' } : { color: 'rgba(148,163,184,0.12)' }
            });
        });

        this.nodesDS.update(nodeUpdates);
        this.edgesDS.update(edgeUpdates);

        this.network.redraw();
    }


    private highlightByEdge(edgeId: string): void {
        if (!this.edgesDS || !this.nodesDS) return;

        const edge = this.edgesDS.get(edgeId) as any;
        if (!edge) return;

        // let onNodes = new Set<string>([String(edge.from), String(edge.to)]);
        let onNodes = [String(edge.from), String(edge.to)];
        const onEdge = edgeId;

        let target = edge.from;
        if (target == WizRoute.segment.id) {
            target = edge.to;
        }

        // edges
        const edgeUpdates: any[] = [];
        this.edgesDS.forEach((e: any) => {
            let isOn = false;

            if (e.from === target) {
                onNodes.push(e.to);
                isOn = true;
            }
            if (e.to === target) {
                onNodes.push(e.from);
                isOn = true;
            }

            if (isOn) {
                edgeUpdates.push({
                    id: e.id,
                    width: 3,
                    color: { color: '#64748B' }
                });
            } else {
                edgeUpdates.push({
                    id: e.id,
                    width: 1,
                    color: { color: 'rgba(148,163,184,0.12)' }
                });
            }
        });

        // nodes
        const nodeUpdates: any[] = [];
        this.nodesDS.forEach((n: any) => {
            const isOn = onNodes.includes(n.id);
            if (isOn) return;

            nodeUpdates.push({
                id: n.id,
                color: { background: 'rgba(148,163,184,0.20)', border: 'rgba(148,163,184,0.20)' },
                font: { ...(n.font ?? {}), color: 'rgba(112,121,136,0.35)' }
            });
        });

        this.nodesDS.update(nodeUpdates);
        this.edgesDS.update(edgeUpdates);
        this.network.redraw();
    }


    private restoreStyles(): void {
        if (!this.nodesDS || !this.edgesDS) return;

        const nodeUpdates: any[] = [];
        this.nodesDS.forEach((n: any) => {
            const orig = this.originalNodeStyle.get(n.id);
            nodeUpdates.push({
                id: n.id,
                color: orig ? this.deepClone(orig.color) : n.color,
                font: orig ? this.deepClone(orig.font) : n.font,
                value: orig?.value ?? n.value,
                borderWidth: orig?.borderWidth ?? 1
            });

        });

        const edgeUpdates: any[] = [];
        this.edgesDS.forEach((e: any) => {
            const orig = this.originalEdgeStyle.get(e.id);
            edgeUpdates.push({
                id: e.id,
                color: orig ? this.deepClone(orig.color) : { color: '#94a3b8' },
                width: orig?.width ?? 1,
                font: orig ? this.deepClone(orig.font) : e.font
            });
        });

        this.nodesDS.update(nodeUpdates);
        this.edgesDS.update(edgeUpdates);

        this.network.redraw();
    }


    private getGradientBlue(value: number, min: number, max: number): string {
        let t = (value - min) / (max - min);

        const light = { r: 215, g: 226, b: 255 }; // 밝은 블루 (#D7E2FF)
        const dark = { r: 15, g: 27, b: 102 }; // 남색 (#0F1B66)

        // t가 작을수록 light → t가 클수록 dark
        const r = Math.round(light.r + (dark.r - light.r) * t);
        const g = Math.round(light.g + (dark.g - light.g) * t);
        const b = Math.round(light.b + (dark.b - light.b) * t);

        return `rgb(${r}, ${g}, ${b})`;
    }

    public downloadNetworkImage() {
        if (!this.network) return;

        const anyNetwork = this.network as any;
        const canvas: HTMLCanvasElement | undefined = anyNetwork?.canvas?.frame?.canvas;

        if (!canvas) {
            console.error('Canvas not found on network');
            return;
        }

        const w = canvas.width;
        const h = canvas.height;

        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = w;
        tempCanvas.height = h;
        const ctx = tempCanvas.getContext('2d');

        if (!ctx) return;

        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, w, h);

        ctx.drawImage(canvas, 0, 0);

        const dataUrl = tempCanvas.toDataURL('image/png');

        const link = document.createElement('a');
        const filenameBase = this.researcher?.kr_name || 'network';
        link.href = dataUrl;
        link.download = `${filenameBase}_그래프.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }



}

export default PortalNetworkWidgetGraphComponent;